import './sass/style.scss';
import './js/polyfills.js';
import 'intersection-observer';
import './js/Main.ts';